export default "__VITE_ASSET__$TxOhztv__"